(() => {
  const selector = "product-info[id^='MainProduct-']";

  function mountHalftoneBackground() {
    const container = document.querySelector(selector);
    if (!container || container.querySelector('.halftone-product-background')) return;

    const canvas = document.createElement('canvas');
    canvas.className = 'halftone-product-background';
    canvas.setAttribute('aria-hidden', 'true');
    container.prepend(canvas);

    const draw = () => {
      const rect = container.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.max(1, Math.round(rect.width * dpr));
      canvas.height = Math.max(1, Math.round(rect.height * dpr));

      const context = canvas.getContext('2d');
      if (!context) return;

      context.setTransform(dpr, 0, 0, dpr, 0, 0);
      context.clearRect(0, 0, rect.width, rect.height);
      context.fillStyle = '#141414';

      const spacing = Math.max(12, Math.min(18, rect.width / 70));
      const maximumRadius = spacing * 0.47;
      const columns = Math.ceil(rect.width / spacing) + 4;
      const rows = Math.ceil(rect.height / (spacing * 0.866)) + 4;

      for (let row = -2; row < rows; row += 1) {
        for (let column = -2; column < columns; column += 1) {
          const x = column * spacing + (row % 2) * spacing * 0.5;
          const y = row * spacing * 0.866;
          const normalizedX = x / rect.width;
          const normalizedY = y / rect.height;
          const waveA = Math.sin((normalizedX * 2.7 + normalizedY * 1.15) * Math.PI * 1.55);
          const waveB = Math.sin((normalizedX * 1.1 - normalizedY * 2.15) * Math.PI * 1.55 + 1.35);
          const waveC = Math.cos((normalizedX * 3.55 + normalizedY * 0.5) * Math.PI + 0.4);
          const field = waveA * 0.52 + waveB * 0.31 + waveC * 0.17;
          const value = Math.max(0, Math.min(1, 0.5 + field * 0.58));
          const radius = 0.35 + maximumRadius * Math.pow(value, 1.7);

          context.beginPath();
          context.arc(x, y, radius, 0, Math.PI * 2);
          context.fill();
        }
      }
    };

    draw();
    new ResizeObserver(draw).observe(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountHalftoneBackground, { once: true });
  } else {
    mountHalftoneBackground();
  }

  document.addEventListener('shopify:section:load', mountHalftoneBackground);
})();
